import React from 'react';

const status = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	return (
     	<div className="material-switch">
          <input type="checkBox" id={fieldDetail.id} name={props.fieldKey} checked={fieldDetail.value} value={fieldDetail.value} onChange={props.changed}/>
          <label htmlFor={fieldDetail.id} className="secondary_bg"></label>
      </div>
	);
}

export default status;